export enum EMicrodatasSlogans {
  DE = 'Gebrauchte Mode verkauft von ihrer Community',
  EN = 'Desirable pre-loved fashion sold by your community',
  ES = 'Moda de lujo de segunda mano',
  FR = 'Le meilleur de la mode de seconde main',
  IT = 'Moda pre-loved venduta dalla nostra community',
  UK = 'Desirable pre-loved fashion sold by your community',
  US = 'Desirable pre-loved fashion sold by your community',
  WW = 'Desirable pre-loved fashion sold by your community'
}
